import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { black, ButtonBrand, gold } from '../../../getLPTheme';
import Container from '@mui/material/Container';
import { IconButton, InputAdornment } from '@mui/material';



export default function ContactForm() {

  return (
    <Container sx={{display:'flex', flexDirection: 'column', alignItems: 'center', pt: { xs: 10, sm: 12 }, pb: { xs: 2, sm: 6 },}}>
      <Box sx={{ display: {xs: 'none', sm: 'flex', md: 'flex', lg: 'flex', xl: 'flex'}, borderRadius: 2, bgcolor: black[1000], height: '70vh', direction: "column", justifyContent: "center", alignItems: "center"}}>
        <Grid>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:"center"}}>
            <Box sx={{width: 400, border: 1, borderColor: gold[500], padding: 1,  display:"flex", flexDirection: 'column', alignItems:"center", justifyContent:"center"}}>
              <Box><Typography sx={{}}>QUERÉS SER SOCIO PARTNERS DE WGC ? <br/>ESCRIBINOS: </Typography></Box>
              <Box sx={{ padding: 1, width: 500, display:"grid", direction: "column", alignItems:"center", justifyContent:"center"}}> 
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa tu Nombre' type='text' required sx={{ }}/>
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa tu Apellido' type='text' required/>
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa Empresa' type='text' required/>
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa tu email' type='email' required sx={{ }}/>
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa tu Telefono' type='email' required sx={{ }}/>
                <TextField multiline={true} rows={3} InputLabelProps={{ shrink: false}} margin="dense"  label='' placeholder='Qué servicio corporativo estás buscando?' type='email' required sx={{ }}/>
                <Box sx={{mt:2}}>
                  <ButtonBrand type='submit' fullWidth>
                    Enviar Información
                  </ButtonBrand>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Box>


      <Box sx={{display: {xs: 'flex', sm: 'none', md: 'none', lg: 'none', xl: 'none'} , borderRadius: 2, bgcolor: black[1000], height: '70vh', direction: "column", justifyContent: "center", alignItems: "center"}}>
        <Grid>
          <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:"center"}}>
            <Box sx={{width: 310, border: 1, borderColor: gold[500], padding: 1, display:"flex", flexDirection: 'column', alignItems:"center", justifyContent:"center"}}>
              <Box><Typography sx={{}}>QUERÉS SER SOCIO PARTNERS DE WGC ? <br/>ESCRIBINOS: </Typography></Box>
              <Box sx={{ padding: 1, width: 500, display:"grid", direction: "column", alignItems:"center", justifyContent:"center"}}> 
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa tu Nombre' type='text' required sx={{ }}/>
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa tu Apellido' type='text' required/>
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa Empresa' type='text' required/>
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa tu email' type='email' required sx={{ }}/>
                <TextField InputLabelProps={{ shrink: false }} margin="dense"  label='' placeholder='Ingresa tu Telefono' type='email' required sx={{ }}/>
                <TextField multiline={true} rows={3} InputLabelProps={{ shrink: false}} margin="dense"  label='' placeholder='Qué servicio corporativo estás buscando?' type='email' required sx={{ }}/>
                <Box sx={{mt:2}}>
                  <ButtonBrand type='submit' fullWidth>
                    Enviar Información
                  </ButtonBrand>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Box>


    </Container>
  );
}